import React, { useRef } from 'react';

import { useCurrentUser } from 'Auth';

import { useChildComponent } from '@gogame/hooks-ts';

import PartnerCompanyDetails from 'scenes/PartnerCompanies/components/PartnerCompanyDetails';
import { useLoadPartnerCompany } from 'scenes/PartnerCompanies/data';
import {
  useUpdatePartnerCompany,
  useCreatePartnerCompany,
} from 'scenes/PartnerCompanies/data/mutations';

import PartnerCompanyForm from './PartnerCompanyForm';
import { OWNER, NAME } from './constants';

export const PartnerCompanyFormCreate = ({
  onSubmit,
  onClose,
  onExited,
  open,
}) => {
  const formRef = useRef(null);
  const user = useCurrentUser();

  const [childComponent, openChildComponent] = useChildComponent();
  const [createPartnerCompany, { isLoading }] = useCreatePartnerCompany();

  const handleSubmit = async (values = {}) => {
    const createdPartnerCompany = await createPartnerCompany(
      values,
      ({ id: existId }) => {
        openChildComponent(PartnerCompanyDetails, { id: existId });
      }
    );

    onSubmit(createdPartnerCompany);
  };

  return (
    <PartnerCompanyForm
      title={'Add Partner Company'}
      loading={isLoading}
      onClose={onClose}
      initialValues={{
        [OWNER]: user.id,
      }}
      onSubmit={handleSubmit}
      onExited={onExited}
      open={open}
      isShowPartnerPartnerCompany={true}
      ref={formRef}
    >
      {childComponent}
    </PartnerCompanyForm>
  );
};

export const PartnerCompanyFormEdit = ({
  id,
  onClose,
  onSubmit,
  onExited,
  open,
}) => {
  const formRef = useRef(null);

  const [updatePartnerCompany, { isLoading: updating }] =
    useUpdatePartnerCompany();

  const { data, isLoading: loading } = useLoadPartnerCompany(id);
  const [childComponent, openChildComponent] = useChildComponent();

  const handleSubmit = async (values) => {
    const response = await updatePartnerCompany(values, ({ id: existId }) => {
      openChildComponent(PartnerCompanyDetails, { id: existId });
    });
    onSubmit(response);
  };

  return (
    <PartnerCompanyForm
      title={'Edit Partner Company'}
      subTitle={data?.[NAME]}
      entityId={id}
      loading={loading || updating}
      onClose={onClose}
      initialValues={data}
      active={!!data}
      onSubmit={handleSubmit}
      onExited={onExited}
      open={open}
      isShowPartnerPartnerCompany={false}
      isEdit={true}
      ref={formRef}
    >
      {childComponent}
    </PartnerCompanyForm>
  );
};
